<template>
  <!-- Add Customer -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Ajouter un nouveau Tier</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.nom }"
                        v-model="form.nom"
                        placeholder="Entrez le Nom"
                        @input="clearFieldError('create', 'nom')"
                      />
                      <div v-if="errors.nom" class="invalid-feedback d-block">{{ errors.nom }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.prenom }"
                        v-model="form.prenom"
                        placeholder="Entrez le Prénom"
                        @input="clearFieldError('create', 'prenom')"
                      />
                      <div v-if="errors.prenom" class="invalid-feedback d-block">{{ errors.prenom }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Civilité</label>
                      <vue-select :options="Civilite" id="choosecus" placeholder="Choose" v-model="form.civilite" />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">CIN</label>
                      <input class="form-control form-control-lg group_formcontrol" type="text" v-model="form.cin"
                        placeholder="Entrez le CIN" />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.adresse }"
                        v-model="form.adresse"
                        placeholder="Entrez l'adresse"
                        @input="clearFieldError('create', 'adresse')"
                      />
                      <div v-if="errors.adresse" class="invalid-feedback d-block">{{ errors.adresse }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': !!(errors.email || clientEmailError) }"
                        v-model="form.email"
                        placeholder="Entrez l'Email"
                        @input="clearFieldError('create', 'email')"
                        @blur="validateClientEmail('create')"
                      />
                      <div v-if="errors.email || clientEmailError" class="invalid-feedback d-block">
                        {{ errors.email || clientEmailError }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Télephone</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.telephone }"
                        v-model="form.telephone"
                        placeholder="Entrez le Télephone"
                        @input="clearFieldError('create', 'telephone')"
                      />
                      <div v-if="errors.telephone" class="invalid-feedback d-block">{{ errors.telephone }}</div>
                    </div>
                  </div>

                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Pays</label>
                      <div :class="{ 'is-invalid-select2': !!errors.pays }">
                        <vue-select
                          :options="Countries"
                          :settings="addModalSelectSettings"
                          id="choosecuss"
                          placeholder="Rechercher un pays"
                          v-model="form.pays"
                          @input="clearFieldError('create', 'pays')"
                        />
                      </div>
                      <div v-if="errors.pays" class="invalid-feedback d-block">{{ errors.pays }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-if="villesData && villesData.length > 0">
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <div :class="{ 'is-invalid-select2': !!errors.ville }">
                        <vue-select
                          :options="villesData"
                          :settings="addModalSelectSettings"
                          id="sellingtypess"
                          placeholder="Rechercher une ville"
                          v-model="form.ville"
                          @input="clearFieldError('create', 'ville')"
                        />
                      </div>
                      <div v-if="errors.ville" class="invalid-feedback d-block">{{ errors.ville }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-else>
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.ville }"
                        v-model="form.ville"
                        @input="clearFieldError('create', 'ville')"
                      />
                      <div v-if="errors.ville" class="invalid-feedback d-block">{{ errors.ville }}</div>
                    </div>
                  </div>

                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type</label>
                      <vue-select :options="Types" id="choosecusss" placeholder="Choisir" v-model="form.type" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type Client</label>
                      <vue-select :options="ClientsType" id="choosecu" placeholder="Choisir"
                        v-model="form.type_client" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">Nom du Sociète</label>
                      <input type="text" class="form-control" v-model="form.nom_societe"
                        :class="{ 'is-invalid': !!errors.nom_societe }"
                        placeholder="Entrez le Nom du Société"
                        @input="clearFieldError('create', 'nom_societe')" />
                      <div v-if="errors.nom_societe" class="invalid-feedback d-block">{{ errors.nom_societe }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">ICE</label>
                      <input type="text" class="form-control" v-model="form.ice" placeholder="Entrez l'ICE" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">RC</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors.rc }"
                        v-model="form.rc"
                        placeholder="Entrez le RC"
                        @input="clearFieldError('create', 'rc')"
                      />
                      <div v-if="errors.rc" class="invalid-feedback d-block">{{ errors.rc }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">TP</label>
                      <input type="text" class="form-control" v-model="form.tp" placeholder="Entrez le TP" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">Identifiant Fiscal</label>
                      <input type="text" class="form-control" v-model="form.identifiant_fiscal"
                        placeholder="Entrez l'Identifiant Fiscal" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Plafond du crédit</label>
                      <input type="number" min="0" class="form-control" v-model="form.plafond_credit"
                        :class="{ 'is-invalid': !!errors.plafond_credit }"
                        placeholder="Entrez le Plafond du crédit"
                        @input="clearFieldError('create', 'plafond_credit')" />
                      <div v-if="errors.plafond_credit" class="invalid-feedback d-block">{{ errors.plafond_credit }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Délai de Paiement</label>
                      <input type="number" min="0" class="form-control" v-model="form.delai_paiement"
                        :class="{ 'is-invalid': !!errors.delai_paiement }"
                        placeholder="Entrez le Délai de Paiement"
                        @input="clearFieldError('create', 'delai_paiement')" />
                      <div v-if="errors.delai_paiement" class="invalid-feedback d-block">{{ errors.delai_paiement }}</div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label">Informations Complementaires</label>
                      <textarea class="form-control mb-1" v-model="form.informations_complementaires" 
                        :class="{ 'is-invalid': !!errors.informations_complementaires }"
                        placeholder="Entrez les Informations Complementaires"
                        @input="clearFieldError('create', 'informations_complementaires')"
                      ></textarea>
                      <div v-if="errors.informations_complementaires" class="invalid-feedback d-block">
                        {{ errors.informations_complementaires }}
                      </div>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Customer -->

  <!-- Edit Customer -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Modifier un Client</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm1">
                <div class="row">
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.nom }"
                        v-model="form1.nom"
                        @input="clearFieldError('edit', 'nom')"
                      />
                      <div v-if="errors1.nom" class="invalid-feedback d-block">{{ errors1.nom }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Prénom</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.prenom }"
                        v-model="form1.prenom"
                        @input="clearFieldError('edit', 'prenom')"
                      />
                      <div v-if="errors1.prenom" class="invalid-feedback d-block">{{ errors1.prenom }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Civilité</label>
                      <vue-select :options="Civilite" id="choosecuaa" placeholder="Choose" v-model="form1.civilite" />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">CIN</label>
                      <input class="form-control form-control-lg group_formcontrol" type="text" v-model="form1.cin"
                        :class="{ 'is-invalid': !!errors1.cin }"
                        @input="clearFieldError('edit', 'cin')" />
                      <div v-if="errors1.cin" class="invalid-feedback d-block">{{ errors1.cin }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.adresse }"
                        v-model="form1.adresse"
                        @input="clearFieldError('edit', 'adresse')"
                      />
                      <div v-if="errors1.adresse" class="invalid-feedback d-block">{{ errors1.adresse }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input type="email" class="form-control"
                        :class="{ 'is-invalid': !!(errors1.email || clientEmailErrorEdit) }"
                        v-model="form1.email"
                        @input="clearFieldError('edit', 'email')"
                        @blur="validateClientEmail('edit')" />
                      <div v-if="errors1.email || clientEmailErrorEdit" class="invalid-feedback d-block">
                        {{ errors1.email || clientEmailErrorEdit }}
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Télephone</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.telephone }"
                        v-model="form1.telephone"
                        @input="clearFieldError('edit', 'telephone')"
                      />
                      <div v-if="errors1.telephone" class="invalid-feedback d-block">{{ errors1.telephone }}</div>
                    </div>
                  </div>

                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Pays</label>
                      <div :class="{ 'is-invalid-select2': !!errors1.pays }">
                        <vue-select
                          :options="Countries"
                          :settings="editModalSelectSettings"
                          id="choosecusssasas"
                          placeholder="Rechercher un pays"
                          v-model="form1.pays"
                          @input="clearFieldError('edit', 'pays')"
                        />
                      </div>
                      <div v-if="errors1.pays" class="invalid-feedback d-block">{{ errors1.pays }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-if="villesData && villesData.length > 0">
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <div :class="{ 'is-invalid-select2': !!errors1.ville }">
                        <vue-select
                          :options="villesData"
                          :settings="editModalSelectSettings"
                          id="sellingtypessdedede"
                          placeholder="Rechercher une ville"
                          v-model="form1.ville"
                          @input="clearFieldError('edit', 'ville')"
                        />
                      </div>
                      <div v-if="errors1.ville" class="invalid-feedback d-block">{{ errors1.ville }}</div>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0" v-else>
                    <div class="mb-3">
                      <label class="form-label">Ville</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.ville }"
                        v-model="form1.ville"
                        @input="clearFieldError('edit', 'ville')"
                      />
                      <div v-if="errors1.ville" class="invalid-feedback d-block">{{ errors1.ville }}</div>
                    </div>
                  </div>

                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type</label>
                      <vue-select :options="Types" id="choosecusssfrfrfg" placeholder="Choisir" v-model="form1.type" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Type Client</label>
                      <vue-select :options="ClientsType" id="choosecutytyy" placeholder="Choisir"
                        v-model="form1.type_client" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form1.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">Nom du Sociète</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.nom_societe }"
                        v-model="form1.nom_societe"
                        @input="clearFieldError('edit', 'nom_societe')"
                      />
                      <div v-if="errors1.nom_societe" class="invalid-feedback d-block">{{ errors1.nom_societe }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form1.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">ICE</label>
                      <input type="text" class="form-control" v-model="form1.ice" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form1.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">RC</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.rc }"
                        v-model="form1.rc"
                        @input="clearFieldError('edit', 'rc')"
                      />
                      <div v-if="errors1.rc" class="invalid-feedback d-block">{{ errors1.rc }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form1.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">TP</label>
                      <input type="text" class="form-control" v-model="form1.tp" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0" v-if="form1.type === 'Professionnel'">
                    <div class="mb-3">
                      <label class="form-label">Identifiant Fiscal</label>
                      <input type="text" class="form-control" v-model="form1.identifiant_fiscal" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Plafond du crédit</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.plafond_credit }"
                        v-model="form1.plafond_credit"
                        @input="clearFieldError('edit', 'plafond_credit')"
                      />
                      <div v-if="errors1.plafond_credit" class="invalid-feedback d-block">{{ errors1.plafond_credit }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Délai de Paiement</label>
                      <input
                        type="number"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': !!errors1.delai_paiement }"
                        v-model="form1.delai_paiement"
                        @input="clearFieldError('edit', 'delai_paiement')"
                      />
                      <div v-if="errors1.delai_paiement" class="invalid-feedback d-block">{{ errors1.delai_paiement }}</div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label">Informations Complementaires</label>
                      <textarea class="form-control mb-1" v-model="form1.informations_complementaires"
                        :class="{ 'is-invalid': !!errors1.informations_complementaires }"
                        @input="clearFieldError('edit', 'informations_complementaires')"
                      ></textarea>
                      <div v-if="errors1.informations_complementaires" class="invalid-feedback d-block">
                        {{ errors1.informations_complementaires }}
                      </div>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Customer -->
</template>
<script>
import {
  createClient,
  updateClient,
  checkClientEmail,
} from "@/services/clientsService";
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import countriesJSON from "@/assets/json/countries.json";
import citiesJSON from "@/assets/json/cities.json";
import { toast } from "vue3-toastify";

const categories = [
  "Électronique",
  "Mode",
  "Maison & Cuisine",
  "Livres",
  "Sports & Plein air",
  "Jouets & Jeux",
  "Beauté & Soins personnels",
  "Santé & Bien-être",
  "Automobile",
  "Fournitures pour animaux",
  "Informatique",
  "Bricolage & Outils",
  "Jardin & Extérieur",
  "Instruments de musique",
  "Films & Séries",
  "Jeux vidéo",
  "Articles de bureau",
  "Bagagerie & Voyage",
  "Alimentation & Boissons",
  "Art & Artisanat",
];
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        adresse: "",
        informations_complementaires: "",
        ville: "",
        pays: "Maroc",
        civilite: "",
        nom: "",
        prenom: "",
        cin: "",
        email: "",
        telephone: "",
        type: "",
        type_client: "",
        user_id: null,
        plafond_credit: null,
        delai_paiement: null,
        societe_id: null,
        nom_societe: "",
        ice: "",
        rc: "",
        tp: "",
        identifiant_fiscal: "",
      },
      form1: {
        id: null,
        adresse: "",
        informations_complementaires: "",
        ville: "",
        pays: "Maroc",
        civilite: "",
        nom: "",
        prenom: "",
        cin: "",
        email: "",
        telephone: "",
        type: "",
        type_client: "",
        user_id: null,
        plafond_credit: null,
        delai_paiement: null,
        societe_id: null,
        nom_societe: "",
        ice: "",
        rc: "",
        tp: "",
        identifiant_fiscal: "",
      },
      // Bootstrap validation errors (red borders)
      errors: {},
      errors1: {},
      clientEmailError: "",
      clientEmailErrorEdit: "",
      clientEmailCheckTimer: null,
      clientEmailCheckTimerEdit: null,
      Countries: [
        "Afghanistan",
        "Afrique du Sud",
        "Albanie",
        "Algérie",
        "Allemagne",
        "Andorre",
        "Angola",
        "Antigua-et-Barbuda",
        "Arabie saoudite",
        "Argentine",
        "Arménie",
        "Australie",
        "Autriche",
        "Azerbaïdjan",
        "Bahamas",
        "Bahreïn",
        "Bangladesh",
        "Barbade",
        "Belgique",
        "Belize",
        "Bénin",
        "Bhoutan",
        "Biélorussie",
        "Birmanie (Myanmar)",
        "Bolivie",
        "Bosnie-Herzégovine",
        "Botswana",
        "Brésil",
        "Brunei",
        "Bulgarie",
        "Burkina Faso",
        "Burundi",
        "Cambodge",
        "Cameroun",
        "Canada",
        "Cap-Vert",
        "Chili",
        "Chine",
        "Chypre",
        "Colombie",
        "Comores",
        "Congo (Brazzaville)",
        "Congo (RDC)",
        "Corée du Nord",
        "Corée du Sud",
        "Costa Rica",
        "Côte d'Ivoire",
        "Croatie",
        "Cuba",
        "Danemark",
        "Djibouti",
        "Dominique",
        "Égypte",
        "Émirats arabes unis",
        "Équateur",
        "Érythrée",
        "Espagne",
        "Estonie",
        "Eswatini",
        "États-Unis",
        "Éthiopie",
        "Fidji",
        "Finlande",
        "France",
        "Gabon",
        "Gambie",
        "Géorgie",
        "Ghana",
        "Grèce",
        "Grenade",
        "Guatemala",
        "Guinée",
        "Guinée équatoriale",
        "Guinée-Bissau",
        "Guyana",
        "Haïti",
        "Honduras",
        "Hongrie",
        "Inde",
        "Indonésie",
        "Iran",
        "Irak",
        "Irlande",
        "Islande",
        "Italie",
        "Jamaïque",
        "Japon",
        "Jordanie",
        "Kazakhstan",
        "Kenya",
        "Kirghizistan",
        "Kiribati",
        "Koweït",
        "Laos",
        "Lesotho",
        "Lettonie",
        "Liban",
        "Libéria",
        "Libye",
        "Liechtenstein",
        "Lituanie",
        "Luxembourg",
        "Macédoine du Nord",
        "Madagascar",
        "Malaisie",
        "Malawi",
        "Maldives",
        "Mali",
        "Malte",
        "Maroc",
        "Îles Marshall",
        "Maurice",
        "Mauritanie",
        "Mexique",
        "Micronésie",
        "Moldavie",
        "Monaco",
        "Mongolie",
        "Monténégro",
        "Mozambique",
        "Namibie",
        "Nauru",
        "Népal",
        "Nicaragua",
        "Niger",
        "Nigéria",
        "Norvège",
        "Nouvelle-Zélande",
        "Oman",
        "Ouganda",
        "Ouzbékistan",
        "Pakistan",
        "Palaos",
        "Palestine",
        "Panama",
        "Papouasie-Nouvelle-Guinée",
        "Paraguay",
        "Pays-Bas",
        "Pérou",
        "Philippines",
        "Pologne",
        "Portugal",
        "Qatar",
        "Roumanie",
        "Royaume-Uni",
        "Russie",
        "Rwanda",
        "Saint-Kitts-et-Nevis",
        "Sainte-Lucie",
        "Saint-Marin",
        "Saint-Vincent-et-les-Grenadines",
        "Salvador",
        "Samoa",
        "Sao Tomé-et-Principe",
        "Sénégal",
        "Serbie",
        "Seychelles",
        "Sierra Leone",
        "Singapour",
        "Slovaquie",
        "Slovénie",
        "Somalie",
        "Soudan",
        "Soudan du Sud",
        "Sri Lanka",
        "Suède",
        "Suisse",
        "Suriname",
        "Syrie",
        "Tadjikistan",
        "Tanzanie",
        "Tchad",
        "République tchèque",
        "Thaïlande",
        "Timor oriental",
        "Togo",
        "Tonga",
        "Trinité-et-Tobago",
        "Tunisie",
        "Turkménistan",
        "Turquie",
        "Tuvalu",
        "Ukraine",
        "Uruguay",
        "Vanuatu",
        "Vatican",
        "Venezuela",
        "Viêt Nam",
        "Yémen",
        "Zambie",
        "Zimbabwe",
      ],
      ClientsType: ["FOURNISSEUR", "CLIENT", "PROSPECT"],
      Types: ["Particulié", "Professionnel"],
      Types1: ["INDIVIDUAL", "COMPANY"],
      Civilite: ["M", "MME"],
      ChooseCusOne: ["Varrel", "Varrel"],
      ChooseCityOne: ["Germany", "United State"],
      villesData: [],
      addModalSelectSettings: {
        dropdownParent: "#add-units",
        minimumResultsForSearch: 0,
        width: "100%",
      },
      editModalSelectSettings: {
        dropdownParent: "#edit-units",
        minimumResultsForSearch: 0,
        width: "100%",
      },
      categories,
    };
  },
  methods: {
    clearFieldError(mode, field) {
      if (!field) return;
      if (mode === "edit") {
        if (this.errors1 && Object.prototype.hasOwnProperty.call(this.errors1, field)) {
          const next = { ...this.errors1 };
          delete next[field];
          this.errors1 = next;
        }
        return;
      }
      if (this.errors && Object.prototype.hasOwnProperty.call(this.errors, field)) {
        const next = { ...this.errors };
        delete next[field];
        this.errors = next;
      }
    },
    isBlank(value) {
      return String(value ?? "").trim().length === 0;
    },
    isValidEmail(value) {
      const s = String(value ?? "").trim();
      if (!s) return true;
      // Simple, pragmatic email check (avoid over-validating)
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
    },
    validateCustomerForm(mode = "create") {
      const isEdit = mode === "edit";
      const f = isEdit ? this.form1 : this.form;
      const errs = {};

      // Keep requirements aligned with your previous `required` usage
      if (this.isBlank(f.nom)) errs.nom = "Nom est obligatoire.";
      if (this.isBlank(f.prenom)) errs.prenom = "Prénom est obligatoire.";
      if (isEdit && this.isBlank(f.cin)) errs.cin = "CIN est obligatoire.";
      if (this.isBlank(f.adresse)) errs.adresse = "Adresse est obligatoire.";
      if (this.isBlank(f.telephone)) errs.telephone = "Téléphone est obligatoire.";
      if (this.isBlank(f.pays)) errs.pays = "Pays est obligatoire.";
      if (this.isBlank(f.ville)) errs.ville = "Ville est obligatoire.";

      // Email: optional in create, required in edit (per your old template)
      // Email: optional (validate only if provided)
      if (!this.isBlank(f.email) && !this.isValidEmail(f.email)) {
        errs.email = "Email invalide.";
      }

      // Optional fields: validate only if provided (but keep numeric sanity)
      if (f.plafond_credit !== null && f.plafond_credit !== "") {
        if (Number.isNaN(Number(f.plafond_credit)) || Number(f.plafond_credit) < 0) {
          errs.plafond_credit = "Plafond du crédit doit être >= 0.";
        }
      }
      if (f.delai_paiement !== null && f.delai_paiement !== "") {
        if (Number.isNaN(Number(f.delai_paiement)) || Number(f.delai_paiement) < 0) {
          errs.delai_paiement = "Délai de paiement doit être >= 0.";
        }
      }
      // informations_complementaires is optional; no required rule

      const typeLabel = isEdit ? this.form1.type : this.form.type;
      if (typeLabel === "Professionnel") {
        if (this.isBlank(f.nom_societe)) errs.nom_societe = "Nom de société est obligatoire.";
        if (this.isBlank(f.rc)) errs.rc = "RC est obligatoire.";
      }

      if (isEdit) this.errors1 = errs;
      else this.errors = errs;

      return Object.keys(errs).length === 0;
    },
    scheduleClientEmailCheck(mode = "create") {
      const timerKey = mode === "create" ? "clientEmailCheckTimer" : "clientEmailCheckTimerEdit";
      const errorField = mode === "create" ? "clientEmailError" : "clientEmailErrorEdit";
      const email = mode === "create" ? this.form.email : this.form1.email;

      if (this[timerKey]) {
        clearTimeout(this[timerKey]);
        this[timerKey] = null;
      }

      if (!email) {
        this[errorField] = "";
        return;
      }

      this[timerKey] = setTimeout(() => {
        this.validateClientEmail(mode);
      }, 400);
    },
    async validateClientEmail(mode = "create") {
      const target = mode === "create" ? this.form : this.form1;
      const errorField = mode === "create" ? "clientEmailError" : "clientEmailErrorEdit";
      const email = (target.email || "").trim();
      const ignoreId = mode === "edit" ? this.form1.id : null;

      if (!email) {
        this[errorField] = "";
        return true;
      }

      try {
        const result = await checkClientEmail(email, ignoreId);
        const available = result?.data?.available ?? true;
        this[errorField] = available ? "" : "Cet email est déjà utilisé.";
        return available;
      } catch (error) {
        console.error(error);
        this[errorField] = "";
        return true;
      }
    },
    // Prefer FR translation when available, otherwise fall back to English name
    getCountryDisplayName(c) {
      if (!c) return "";
      const tr = c.translations || {};
      return tr.fr || tr["fr"] || c.name;
    },
    // Build country options from JSON
    buildCountriesOptions() {
      try {
        const list = (countriesJSON || []).map((c) => this.getCountryDisplayName(c));
        this.Countries = Array.from(new Set(list.filter(Boolean))).sort((a, b) =>
          a.localeCompare(b, "fr")
        );
        if (!this.form.pays && this.Countries.length) {
          this.form.pays = this.Countries.includes("Maroc")
            ? "Maroc"
            : this.Countries[0];
        }
      } catch (e) {
        // keep existing static list as fallback
      }
    },
    // Update cities list based on selected country name
    updateCitiesOptionsForPays(paysName) {
      if (!paysName) {
        this.villesData = [];
        return;
      }
      const country = (countriesJSON || []).find(
        (c) => this.getCountryDisplayName(c).toLowerCase() === paysName.toLowerCase()
      );
      if (!country) {
        this.villesData = [];
        return;
      }
      const id = country.id;
      const names = (citiesJSON || [])
        .filter((ct) => ct.country_id === id)
        .map((ct) => ct.name)
        .filter(Boolean);
      this.villesData = Array.from(new Set(names)).sort((a, b) =>
        a.localeCompare(b, "fr")
      );
    },
    // Extract a clear message from Axios/Laravel error responses
    getErrorMessage(error) {
      const data = error && error.response && error.response.data;
      if (!data) return (error && error.message) || "Une erreur est survenue.";
      if (typeof data === "string") return data;
      if (data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstVal = data.errors[firstKey];
        if (Array.isArray(firstVal) && firstVal.length) return firstVal[0];
        if (typeof firstVal === "string") return firstVal;
      }
      if (data.error) return data.error;
      if (data.message) return data.message;
      return "Une erreur est survenue.";
    },
    async submitForm() {
      try {
        if (!this.validateCustomerForm("create")) {
          return toast.error("Veuillez corriger les champs en rouge.");
        }
        let user = decodeToken(localStorage.getItem("access_token"));
        this.form.societe_id = user.societe_id;
        const cin = String(this.form.cin ?? "").trim() || null;
        const email = String(this.form.email ?? "").trim() || null;
        const emailAvailable = await this.validateClientEmail("create");
        if (!emailAvailable) {
          // keep border red via clientEmailError
          return toast.error(this.clientEmailError || "Cet email est déjà utilisé.");
        }
        const response = await createClient({
          adresse: this.form.adresse,
          informations_complementaires: this.form.informations_complementaires,
          ville: this.form.ville,
          pays: this.form.pays,
          civilite: this.form.civilite,
          nom: this.form.nom,
          prenom: this.form.prenom,
          cin,
          email,
          telephone: this.form.telephone,
          type: this.form.type === "Particulié" ? "INDIVIDUAL" : "COMPANY",
          type_client: this.form.type_client,
          user_id: this.form.user_id,
          plafond_credit: this.form.plafond_credit,
          delai_paiement: this.form.delai_paiement,
          societe_id: this.form.societe_id,
          nom_societe: this.form.nom_societe,
          rc: this.form.rc,
          tp: this.form.tp,
          ice: this.form.ice,
          identifiant_fiscal: this.form.identifiant_fiscal,
        });
        this.$emit("client-added", response);
        this.clientEmailError = "";
        this.errors = {};

        const modalElement = document.getElementById("add-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getErrorMessage(error));
      }
    },
    async submitForm1() {
      try {
        if (!this.validateCustomerForm("edit")) {
          return toast.error("Veuillez corriger les champs en rouge.");
        }
        const cin = String(this.form1.cin ?? "").trim() || null;
        const email = String(this.form1.email ?? "").trim() || null;
        const emailAvailable = await this.validateClientEmail("edit");
        if (!emailAvailable) {
          // keep border red via clientEmailErrorEdit
          return toast.error(this.clientEmailErrorEdit || "Cet email est déjà utilisé.");
        }
        const response = await updateClient(this.form1.id, {
          adresse: this.form1.adresse,
          informations_complementaires: this.form1.informations_complementaires,
          ville: this.form1.ville,
          pays: this.form1.pays,
          civilite: this.form1.civilite,
          nom: this.form1.nom,
          prenom: this.form1.prenom,
          cin,
          email,
          telephone: this.form1.telephone,
          type: this.form1.type === "Particulié" ? "INDIVIDUAL" : "COMPANY",
          type_client: this.form1.type_client,
          plafond_credit: this.form1.plafond_credit,
          delai_paiement: this.form1.delai_paiement,
          societe_id: this.form1.societe_id,
          nom_societe: this.form1.nom_societe,
          rc: this.form1.rc,
          tp: this.form1.tp,
          ice: this.form1.ice,
          identifiant_fiscal: this.form1.identifiant_fiscal,
        });
        this.$emit("client-updated", response);
        this.clientEmailErrorEdit = "";
        this.errors1 = {};

        const modalElement = document.getElementById("edit-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        toast.error(this.getErrorMessage(error));
      }
    },
    capitalizeFirstLetter(str) {
      if (!str) return ""; // handle empty string
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
  },
  mounted() {
    // Initialize countries and cities from JSON files
    this.buildCountriesOptions();
    this.updateCitiesOptionsForPays(this.form.pays);
    if (!this.form.ville && this.villesData && this.villesData.length > 0) {
      this.form.ville = this.villesData[0];
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.id = newData.id;
        this.form1.adresse = newData?.adresse || "";
        this.form1.informations_complementaires =
          newData?.informations_complementaires || "";
        this.form1.ville = this.capitalizeFirstLetter(newData?.ville) || "";
        this.form1.pays = this.capitalizeFirstLetter(newData?.pays) || "";
        this.form1.civilite = newData?.civilite || "";
        this.form1.nom = newData?.nom || "";
        this.form1.prenom = newData?.prenom || "";
        this.form1.cin = newData?.cin || "";
        this.form1.email = newData?.email || "";
        this.form1.telephone = newData?.telephone || "";
        this.form1.type =
          newData?.type === "INDIVIDUAL" ? "Particulié" : "Professionnel" || "";
        this.form1.type_client = newData?.type_client || "";
        this.form1.user_id = newData?.user_id || "";
        this.form1.plafond_credit = newData?.plafond_credit || "";
        this.form1.delai_paiement = newData?.delai_paiement || "";
        this.form1.societe_id = newData?.societe_id || "";
        this.form1.nom_societe = newData?.nom_societe || "";
        this.form1.ice = newData?.ice || "";
        this.form1.rc = newData?.rc || "";
        this.form1.tp = newData?.tp || "";
        this.form1.identifiant_fiscal = newData?.identifiant_fiscal || "";
        this.clientEmailErrorEdit = "";
        this.errors1 = {};

        // Ensure edit modal cities are aligned with the loaded country
        if (this.form1.pays) {
          this.updateCitiesOptionsForPays(this.form1.pays);
        }
      },
    },
    // Update cities when selected country changes (add modal)
    "form.pays"(val) {
      this.updateCitiesOptionsForPays(val);
      // Default to the first city if available, otherwise clear
      this.form.ville = this.villesData && this.villesData.length > 0 ? this.villesData[0] : "";
    },
    // Update cities when selected country changes (edit modal)
    "form1.pays"(val) {
      this.updateCitiesOptionsForPays(val);
      // Default to the first city if available, otherwise clear
      this.form1.ville = this.villesData && this.villesData.length > 0 ? this.villesData[0] : "";
    },
    "form.email"(value) {
      if (!value) {
        this.clientEmailError = "";
      }
      this.scheduleClientEmailCheck("create");
    },
    "form1.email"(value) {
      if (!value) {
        this.clientEmailErrorEdit = "";
      }
      this.scheduleClientEmailCheck("edit");
    },
    "form.plafond_credit"() {
      this.clearFieldError("create", "plafond_credit");
    },
    "form.delai_paiement"() {
      this.clearFieldError("create", "delai_paiement");
    },
    "form1.plafond_credit"() {
      this.clearFieldError("edit", "plafond_credit");
    },
    "form1.delai_paiement"() {
      this.clearFieldError("edit", "delai_paiement");
    },
  },
  beforeUnmount() {
    if (this.clientEmailCheckTimer) {
      clearTimeout(this.clientEmailCheckTimer);
    }
    if (this.clientEmailCheckTimerEdit) {
      clearTimeout(this.clientEmailCheckTimerEdit);
    }
  },
};
</script>

<style scoped>
/* Make vue3-select2-component look like a Bootstrap invalid control */
.is-invalid-select2 :deep(.select2-selection) {
  border-color: #dc3545 !important;
}
.is-invalid-select2 :deep(.select2-selection:focus),
.is-invalid-select2 :deep(.select2-selection--single:focus) {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;
}
</style>
